import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { distances, grid } from '../../../styles/constants';
import { Session, Transaction } from '../../../types/checkout';
import TransactionData from './TransactionData';
import TransactionHistory from './TransactionHistory';
import CustomerInfo from '../../components/CustomerInfo';
import DeviceInfo from '../../components/DeviceInfo';
import OrderItems from '../../components/OrderItems';
import OrderShippingAddress from '../../components/OrderShippingAddress';
import OrderBillingAddress from '../../components/OrderBillingAddress';
import OrderShippingOption from './OrderShippingOption';
import { RequestLog as RequestLogType } from '../../../types/audit/generated';
import RequestLog from './RequestLog';

export interface MainAreaProps extends WithTranslation {
    transaction: Transaction;
    session?: Session;
    requestLogs: RequestLogType[] | undefined;
    openEventHistoryDetailsModal: (details: any) => void;
}

const MainArea = (
    {
        transaction,
        session,
        requestLogs,
        openEventHistoryDetailsModal,
    }: MainAreaProps
) => {
    return (
        <Wrapper>
            <SectionsWrapper>
                <OrderItems transaction={transaction} session={session} />
            </SectionsWrapper>
            <Spacer />

            <SectionsWrapper>
                <CustomerInfo transaction={transaction} session={session} />
            </SectionsWrapper>
            <Spacer />

            <SectionsFlexWrapper>
                <OrderShippingAddress transaction={transaction} session={session} />
                <OrderBillingAddress transaction={transaction} session={session} />
            </SectionsFlexWrapper>
            {session && session.order.shipping_option && <OrderShippingOption {...{ transaction, session }} />}
            <Spacer />

            <SectionsFlexWrapper>
                <TransactionData transaction={transaction} session={session} />
                <TransactionHistory
                    transaction={transaction}
                    openEventHistoryDetailsModal={openEventHistoryDetailsModal}
                />
            </SectionsFlexWrapper>
            <Spacer />

            <SectionsWrapper>
                <DeviceInfo transaction={transaction} session={session} />
            </SectionsWrapper>

            <Spacer />
            {requestLogs && requestLogs.length > 0 && (
                <SectionsWrapper>
                    <RequestLog requestLogs={requestLogs} transaction={transaction} />
                </SectionsWrapper>
            )}
        </Wrapper>
    );
};

export default withTranslation()(MainArea);

const Wrapper = styled.div`
  max-width: ${grid.spans.span8};
  margin: 0 auto;
  padding: ${distances.normal} ${distances.small};

  @media (max-width: 768px) {
        padding: ${distances.small};
    }
`;
const SectionsWrapper = styled.div``;
const SectionsFlexWrapper = styled.div`
  display: flex;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

const Spacer = styled.div`
  height: ${distances.large};
`;
